/* eslint-disable import/prefer-default-export */

export function selectPreferredPartnerDetails({ preferredPartnerDetails }) {
	return preferredPartnerDetails.data;
}
